/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import Typewriter from '../../CommonComponents/TypeWriting';
import Divider from '../../CommonComponents/Divider';
import { useDispatch, useSelector } from 'react-redux';
import { isStreamingStarted, loader } from '../../Services/Redux/Reducers/commonSlice';
import { storeChat } from '../../Services/Redux/Reducers/chatSlice';
import { TextOnlyProps } from "../../Services/CommonServices/propTypes";
import { Cookies } from 'react-cookie-consent';

function TextOnly(props) {
    const [isOverviewTextLoading, setIsOverviewTextLoading] = useState(false);
    const [isConclusionLoading, setIsConclusionLoading] = useState(false);
    const dispatch = useDispatch();
    const conList = useSelector((state) => state.chat.conversationList);
    const loading = useSelector((state) => state.common.isLoader)
    const isStopTriggered = useSelector((state) => state.chat.isStopButtonTriggered)

    useEffect(() => {
        if (props.index === conList.length - 1 && loading && props.badIntentResponseCode) {
            dispatch(isStreamingStarted(false));
        }
        if (props.index === conList.length - 1 && loading && props.text || props.conclusion) {
            dispatch(isStreamingStarted(false));
        }
        if (props.index === conList.length - 1 && !isStopTriggered && props.isAnswerComplete && loading) {
            if (
                ((props.text === null || props.text === "") || (props.text != null && isOverviewTextLoading == true)) &&
                (props.conclusion == undefined || props.conclusion == "" || (props.conclusion && props.conclusion != "" && isConclusionLoading == true))
            ) {
                dispatch(storeChat(true));
                dispatch(loader(false));
            }
        }
        // if (!isStopTriggered && !isOverviewTextLoading && !isConclusionLoading && streamingState) {
        //     dispatch(loader(true));
        // }
    }, [props.conclusion, props.isAnswerComplete, props.text, isOverviewTextLoading, isConclusionLoading, loading])

    const renderErrorMessage = () => {
        switch (props.badIntentResponseCode) {
            case "UnsupportedLanguage":
                return <Typewriter convoId={props.convoId} type="responseText" text={"At this time, Ask Ralph can only converse in English. Please try again in English to continue"} delay={props.delay} isAnswerComplete={props.isAnswerComplete} setLoading={setIsOverviewTextLoading} effects={props.effects}
                />
            case "OutOfScope":
                return (
                    <>
                        <div style={{ paddingBottom: '16px', display: 'inline-block' }}>
                            {/* <Typewriter convoId={props.convoId} type="responseText" text={"Ask Ralph is currently designed with extensive knowledge of men's and women's Polo Ralph Lauren products only. To explore all Ralph Lauren brands, please use the link below:"} delay={props.delay} isAnswerComplete={props.isAnswerComplete} setLoading={setIsOverviewTextLoading} effects={props.effects}
                            /> */}
                            <Typewriter convoId={props.convoId} type="responseText" text={"Ask Ralph currently does not support requests regarding these products. To explore all Ralph Lauren products, please use the link below:"} delay={props.delay} isAnswerComplete={props.isAnswerComplete} setLoading={setIsOverviewTextLoading} effects={props.effects}
                            />
                            {
                                isOverviewTextLoading && <a
                                    href={Cookies.get('applicationEnvironment') === "production" ? "rlapp://shop" : "rlappdev://shop"}
                                    className="deeplink-button"
                                >
                                    Shop All Brands
                                </a>
                            }
                        </div>
                    </>
                );
            case "NotSupported":
                return <Typewriter convoId={props.convoId} type="responseText" text={"This feature is currently not supported in the Ask Ralph experience. However, the tool is ready to assist you with product exploration, styling suggestions, gifting, and more."} delay={props.delay} isAnswerComplete={props.isAnswerComplete} setLoading={setIsOverviewTextLoading} effects={props.effects}
                />
            default:
                return <Typewriter convoId={props.convoId} type="responseText" text={"Unable to process your request. Please try again."} delay={props.delay} isAnswerComplete={props.isAnswerComplete} setLoading={setIsOverviewTextLoading} effects={props.effects} responseType='Error'
                />
        }
    };
    return (
        <div>            
            {!isStopTriggered && ((props.badIntentResponseCode !== null && props.badIntentResponseCode !== "Other")) ? (
                <div className="TextResponse">
                    <div className="col-11 chat_options d-flex flex-column mb response_bg">
                        <div className="generic-error-txt bad-intent-error">{renderErrorMessage()}</div>
                    </div>
                </div>
            ) : (props.text || props.conclusion) && (
                <div className="TextResponse">
                    <div className="col-11 chat_options d-flex flex-column mb response_bg">
                        <div className="chat_msg1 col-md-11 col-lg-9 px-0 py-0">
                            <Typewriter convoId={props.convoId} type="responseText" text={props.text} delay={props.delay} isAnswerComplete={props.isAnswerComplete} setLoading={setIsOverviewTextLoading} effects={props.effects} />
                        </div>
                        <div>
                            {((props.index !== conList.length - 1 && props.conclusion && props.conclusion != '') || ((props.text === "" || isOverviewTextLoading) && props.conclusion && props.conclusion != '')) && (
                                <div>
                                    <Divider borderTop="border-1" borderBottom="border-2" />
                                    <div className="col-lg-9 chat_msg1 p-0">
                                        <Typewriter type="responseConclusion" convoId={props.convoId} text={props.conclusion ?? ""} delay={props.delay} isAnswerComplete={props.isAnswerComplete} setLoading={setIsConclusionLoading} effects={props.effects} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

TextOnly.propTypes = TextOnlyProps;

export default TextOnly;